import store from "@/store/store";
import { getterTypes as publisherGetterTypes } from "@/store/Publisher/types";

// Replaces characters that are unsafe or awkward in a file name with underscores
export const toFilenamePart = (value) =>
    String(value || "")
        .trim()
        .replace(/[\\/:*?"<>|\s]+/g, "_");

/**
 * File name prefix for a dashboard report: the selected website's domain for a single website,
 * otherwise the name of the selected publisher (dashboards render data cards for exactly one publisher).
 *
 * @param {string[]} domains selected website domains
 * @param {string} publisherGetter store getter returning the publisher(s) selected on the given dashboard
 */
export const reportFilenamePrefix = (domains, publisherGetter) => {
    if (domains.length === 1) {
        return domains[0];
    }
    const selected = store.getters[publisherGetter];
    const publisher = Array.isArray(selected) ? selected[0] : selected;
    return toFilenamePart(publisher?.name) || "publishers";
};

export const YIELD_PUBLISHER_GETTER = publisherGetterTypes.getSelectedPublishersYield;
export const LTBA_PUBLISHER_GETTER = publisherGetterTypes.getSelectedPublisherLtba;
